import { menuMobile } from "./component/mobile/menu"
import profileMenu from "./component/profileMenu"
import contactsMap from "./component/contact/map"
import { cartInit } from "./component/cart"
import { headerInit } from "./component/header"
import { productInit } from "./component/product"
import { notificationInit } from "./component/notification"
import { smothScrollInit } from "./globals/smoth"
import { compareInit } from "./component/compare"
import { mainInit } from "./component/main"
import { newsInit } from "./component/news"
import { clipboardInit } from "./globals/clipboard"
import { paymentInit } from "./component/payment"
import { searchInit } from "./component/search"
import { catalogInit } from "./component/catalog"
import { authInit } from "./component/auth"
import { floatInputInit } from "./globals/floatinput"
import { faqInit } from "./component/faq/"
import { profileInit } from "./component/profile"
import { documentsInit } from "./component/documents"
import { restorePasswordInit } from "./component/auth/restore"
import { promoInit } from "./component/promo"
import { ecommerceInit } from "./component/ecommerce"

document.addEventListener("DOMContentLoaded", function() {
  if (Sentry) {
    Sentry.init({ dsn: "https://57d748f30d434effa733e31d71242f76@sentry.io/1388709" })
  }

  smothScrollInit()
  clipboardInit()
  menuMobile()
  profileMenu()
  contactsMap()
  productInit()
  headerInit()
  cartInit()
  notificationInit()
  compareInit()
  mainInit()
  newsInit()
  paymentInit()
  searchInit()
  catalogInit()
  authInit()
  restorePasswordInit()
  floatInputInit()
  faqInit()
  profileInit()
  documentsInit()
  promoInit()
  ecommerceInit()
})
